// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__UsziS","headerItem":"Header_headerItem__w1VHB","headerContainer":"Header_headerContainer__kKEW0"};